import axios from "axios";
import { googleAPIKey } from "../firebase-config/google";

export const getAddressDetails = (address: any) => {
  const result = address;
  const { address_components, geometry } = address;

  const addressLine1 = result.name;
  const addressLine2 = "";

  const countryFilter = address_components.filter((e: any) =>
    e.types.includes("country")
  );
  const country = countryFilter?.[0]?.short_name ?? "";

  const zipFilter = address_components.filter((e: any) =>
    e.types.includes("postal_code")
  );
  const zipcode = zipFilter?.[0]?.short_name ?? "";

  const stateFilter = address_components.filter((e: any) =>
    e.types.includes("administrative_area_level_1")
  );
  const state = stateFilter?.[0]?.short_name ?? "";

  const cityFilter = address_components.filter((e: any) =>
    e.types.includes("locality")
  );
  const city = cityFilter?.[0]?.short_name ?? "";

  const latitude = geometry?.location?.lat ?? 0.0;
  const longitude = geometry?.location?.lng ?? 0.0;

  return {
    addressLine1,
    addressLine2,
    country,
    city,
    zipcode,
    state,
    latitude,
    longitude,
  };
};

export const getDetailsFromZipData = (address: any) => {
  const { address_components } = address;

  const countryFilter = address_components.filter((e: any) =>
    e.types.includes("country")
  );
  const country = countryFilter?.[0]?.short_name ?? "";

  const zipFilter = address_components.filter((e: any) =>
    e.types.includes("postal_code")
  );
  const zipcode = zipFilter?.[0]?.short_name ?? "00000";

  const stateFilter = address_components.filter((e: any) =>
    e.types.includes("administrative_area_level_1")
  );
  const state = stateFilter?.[0]?.short_name ?? "";

  const cityFilter = address_components.filter((e: any) =>
    e.types.includes("locality")
  );
  const city = cityFilter?.[0]?.short_name ?? "";
  return {
    country,
    city,
    zipcode,
    state,
  };
};

export const placeDetails = async (placeId: string | undefined) => {
  if (placeId) {
    const url = `https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1/search/placedetails`;

    const details = await axios.post(url, {
      place_id: placeId,
    });
    const { data } = details;

    return getAddressDetails(data?.data);
  }
};
